import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router";
import { DocumentType } from "./useDocuments";

export const enum DocumentTabs {
    YourDocuments,
    YourUploads,
}

const TAB_PARAM = "tab";

const tabValuesAndParams = [
    { value: DocumentTabs.YourDocuments, param: DocumentType.Shared.toLowerCase() },
    { value: DocumentTabs.YourUploads, param: DocumentType.Uploads.toLowerCase() },
];

const initiallyActiveTab = DocumentTabs.YourDocuments;

export function useDocumentsActiveTab() {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = useMemo(() => {
        const tabParam = searchParams.get(TAB_PARAM);
        if (!tabParam) {
            return initiallyActiveTab;
        }

        return tabValuesAndParams.find((tab) => tab.param === tabParam.toLowerCase())?.value ?? initiallyActiveTab;
    }, [searchParams]);

    const setActiveTab = useCallback(
        (value: DocumentTabs) => {
            const param = tabValuesAndParams.find((tab) => tab.value === value).param;
            setSearchParams(
                { [TAB_PARAM]: param },
                {
                    replace: true,
                }
            );
        },
        [setSearchParams]
    );

    return { activeTab, setActiveTab };
}
